<template>
  <div id="shop-edition-product-dialog">
    <v-dialog max-width="500px" scrollable v-model="dialogItem">
      <template v-slot:activator="{ on }">
        <v-btn @click="addItem()" color="primary" dark v-on="on">Create</v-btn>
      </template>
      <v-card>
        <!-- <v-card-title>
          <h1 class="title head-page">Counsulting Topic</h1>
        </v-card-title>-->
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout justify-center row wrap>
              <v-flex xs4>
                <ShopEditionProductPicture :idx="formData.idx" v-if="formData.idx" />
              </v-flex>
              <v-flex xs8>
                <v-autocomplete
                  clearable
                  :items="shopEditions"
                  item-text="name"
                  item-value="idx"
                  label="Shop Edition"
                  v-model="formData.shopEditionId"
                ></v-autocomplete>
                <v-autocomplete
                  clearable
                  data-vv-name="product"
                  :error-messages="errors.collect('product')"
                  :items="products"
                  item-text="productname"
                  item-value="productid"
                  label="Product"
                  v-model="formData.productId"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  clearable
                  @input="checkProvince"
                  :items="provinces"
                  item-text="nametha"
                  item-value="id"
                  label="Province"
                  v-model="formData.province"
                ></v-autocomplete>
                <!-- district -->
                <v-autocomplete
                  clearable
                  :disabled="formData.province ? false : true"
                  @input="checkDistrict"
                  :items="districts"
                  item-text="nametha"
                  item-value="id"
                  label="District"
                  v-model="formData.district"
                ></v-autocomplete>
                <!-- sub district -->
                <v-autocomplete
                  clearable
                  :disabled="formData.district ? false : true"
                  :items="subDistricts"
                  item-text="nametha"
                  item-value="id"
                  label="SubDistrict"
                  v-model="formData.subDistrict"
                ></v-autocomplete>
                <v-textarea
                  clearable
                  label="Description"
                  v-model="formData.description"
                ></v-textarea>
              </v-flex>
              <v-flex xs6>
                <v-menu
                  :close-on-content-click="false"
                  full-width
                  lazy
                  min-width="290px"
                  :nudge-right="40"
                  offset-y
                  transition="scale-transition"
                  v-model="menuStartDate"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      clearable
                      label="Start Date"
                      readonly
                      v-model="formData.startDate"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    @input="menuStartDate = false"
                    no-title
                    v-model="formData.startDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-menu
                  :close-on-content-click="false"
                  full-width
                  lazy
                  min-width="290px"
                  :nudge-right="40"
                  offset-y
                  transition="scale-transition"
                  v-model="menuEndDate"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      clearable
                      label="End Date"
                      readonly
                      v-model="formData.endDate"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    @input="menuEndDate = false"
                    :min="formData.startDate"
                    no-title
                    v-model="formData.endDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <!-- Section 1 -->
              <ShopEditionProductItemTable v-if="formData.idx" />
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            @click="doDelete(formData.idx, formData.picture)"
            color="red"
            dark
            v-if="formData.idx"
            >Delete</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn @click.stop="dialogItem = !dialogItem" color dark>Close</v-btn>
          <v-btn @click="doSubmit()" color="green" dark :loading="dialogLoading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firestorage from 'firebase/app' // Storage
const ShopEditionProductPicture = () => import('@/components/admin/ShopEditionProductPicture')
const ShopEditionProductItemTable = () => import('@/components/admin/ShopEditionProductItemTable')

export default {
  name: 'shop-edition-product-dialog',
  components: {
    ShopEditionProductPicture,
    ShopEditionProductItemTable
  },
  data() {
    return {
      formData: [],
      dialogLoading: false,
      menuStartDate: false,
      menuEndDate: false
    }
  },
  watch: {
    dialogItem() {
      if (this.$store.state.ShopEditionProduct.idx) {
        this.formData = this.$store.getters['ShopEditionProduct/getAll'].filter(
          item => item.idx == this.$store.state.ShopEditionProduct.idx
        )[0]
      } else {
        this.formData = []
      }
    }
  },
  computed: {
    provinces() {
      return this.$store.getters['Place/getProvinceAll']
    },
    districts() {
      return this.$store.getters['Place/getDistrictAll'].filter(
        item => item.provinceid == this.formData.province
      )
    },
    subDistricts() {
      return this.$store.getters['Place/getSubDistrictAll'].filter(
        item => item.districtid == this.formData.district
      )
    },
    shopEditions() {
      return this.$store.state.ShopEdition.data
    },
    products() {
      return this.$store.state.Product.searchProducts
    },
    dialogItem: {
      // getter
      get() {
        return this.$store.state.ShopEditionProduct.dialog
      },
      // setter
      set(newValue) {
        this.$store.commit('ShopEditionProduct/UPDATE_DIALOG', newValue)
      }
    }
  },
  created() {
    if (this.$store.state.Product.searchProducts) this.$store.dispatch('Product/fetchProductSearch')
  },
  methods: {
    checkRegion(region) {
      if (!region) {
        this.formData.provinceId = null
        this.formData.districtId = null
        this.formData.subDistrictId = null
      }
    },
    checkProvince(province) {
      if (!province) {
        this.formData.districtId = null
        this.formData.subDistrictId = null
      }
    },
    checkDistrict(district) {
      if (!district) {
        this.formData.subDistrictId = null
      }
    },
    async doSubmit() {
      try {
        const validate = await this.$validator.validateAll()
        if (validate) {
          this.dialogLoading = !this.dialogLoading
          const data = {
            ...this.formData
          }
          await this.$store.dispatch(`ShopEditionProduct/insert`, data)
          this.$store.commit(`ShopEditionProduct/UPDATE_DIALOG`, false)
          this.formData = []
          this.dialogLoading = !this.dialogLoading
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    doDelete(idx, picture) {
      const answer = window.confirm(`Do you want to Delete ${idx} ?`)
      if (answer) {
        if (picture) {
          // Create a reference to the file to delete
          var desertRef = firestorage.storage().refFromURL(picture)
          // Delete the file
          desertRef.delete()
        }
        // Delete in DB
        this.$store.dispatch(`ShopEditionProduct/delete`, idx)
        this.$store.commit(`ShopEditionProduct/UPDATE_DIALOG`, false)
      }
    },
    addItem() {
      this.$store.commit('ShopEditionProduct/UPDATE_DIALOG', true)
      this.$store.commit('ShopEditionProduct/SET_IDX', null)
    }
  }
}
</script>

<style lang="scss" scoped></style>
